<template>
  <v-app class="bgLightGreen boiler-page" id="inspire">
    <Header back header-text="lng_setup"></Header>
    <flash-message
      v-if="alertToggle"
      :message-data="flashMessageData"
      :alert-toggle="alertToggle"
      :do-translation="false"
      @alertToggleUpdate="flashMessageTimeOut()"
    >
    </flash-message>
    <v-container fluid v-if="userMenu" :key="submenuKey">
      <app-menu page-name="System" :expiry-flag="Number(expiryFlag)"></app-menu>
      <v-layout row wrap justify-center>
        <v-flex
          v-for="subMenu in userMenu.menu.submenu"
          :key="subMenu['@attributes'].txtid"
          xs12
          md6
          class="px-4 panel-block"
        >
          <system-submenu
            v-if="subMenu && userMenuData"
            :sub-menu="subMenu"
            :sub-menu-data="userMenuData"
            :sub-menu-select-data="userMenu.menu.fieldsets.fieldset"
            :response-alert="setResponseAlert"
            :keystroke-value="pressKeystrokeW"
            @showAdvancedMode="showAdvancedMode"
            @saveLang="submenuKey++"
            :key="subMenu['@attributes'].txtid + submenuKey"
          />
        </v-flex>
      </v-layout>
    </v-container>
  </v-app>
</template>

<script>
import { mapGetters } from "vuex";
import Header from "../components/Header";
import GlobalService from "../services/global-service";
import Menu from "../components/menus/Menu";
import FlashMessage from "../components/FlashMessage";
import SystemSubmenu from "../components/SystemSubmenu";
import { menuItems } from "../common/SystemUserMenu";
import { translate } from "../common/HelperFunctions";

export default {
  components: {
    Header,
    appMenu: Menu,
    FlashMessage,
    SystemSubmenu
  },
  data: () => ({
    userMenu: undefined,
    userMenuData: undefined,
    alertToggle: false,
    flashMessageData: {},
    responseObj: {},
    outputSettings: undefined,
    filteredOutputSettings: [],
    submenuKey: 0,
    pressKeystrokeW: 0,
    expiryFlag: undefined
  }),
  async created() {
    // start page loading component
    this.$store.commit("global/setLoading", true);
    this.userMenu = menuItems;
    this.expiryFlag = localStorage.getItem("expiryFlag");
    await this.FetchApisData();
  },
  mounted() {
    let that = this;
    document.getElementsByTagName("html")[0].className = "";
    // add event Listener for key press
    document.addEventListener("keypress", function onEvent(event) {
      if (event.key === "w") {
        that.pressKeystrokeW += 1;
      }
    });
  },
  computed: {
    ...mapGetters("user", ["getUser"])
  },
  methods: {
    showAdvancedMode() {
      this.pressKeystrokeW = 3;
    },
    async FetchApisData() {
      this.userMenuData = await GlobalService.getMenuData(
        "setup",
        this.getUser.token
      );
      this.$store.commit("global/setLoading", false);
    },
    // to show the resposne alert on update field
    setResponseAlert(resObj) {
      this.alertToggle = true;
      this.responseObj = resObj;
      this.flashMessageData = {
        saved: resObj.onlineandsaved ? "lng_save_ok" : "lng_save_notok",
        messageText: resObj.onlineandsaved
          ? `${translate("lng_save_ok")}`
          : `${translate("lng_save_notok")}`,
        showRegisterButton: false,
        color: resObj.onlineandsaved ? "rgba(76, 175, 80, 0.9)" : "red"
      };
      if (resObj.secs_to_next_update > 0) {
        this.pageRefreshTime = resObj.secs_to_next_update;
      }
    },
    flashMessageTimeOut() {
      this.alertToggle = false;
      this.responseObj = {};
    }
  }
};
</script>
